import Vue from 'vue'
import Vuex from 'vuex'

import { app } from '@/plugins/store/app'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app
  }
})
